import EditorError from './EditorError';

export default EditorError;
